module.exports = __webpack_public_path__ + "static/p1-1ba127b43331892e5164b164b1e19012.jpg";